<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="text-center" :to="{ path: '/sys/linXuanChannel/list' }"
      >渠道申报</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
        class="flex-item role-form"
        ref="validateForm"
        :model="form"
        size="mini"
        :rules="rules"
        :validate-on-rule-change="false"
        label-width="250px"
    >
      <el-row>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="渠道基础信息填写区" name="1">
          <el-col :span="11">
            <el-form-item label="企业名称:" prop="channelName">
              <el-input v-model="form.channelName" :readonly="isReadOnly"  :maxlength="100" show-word-limit placeholder="请输入企业名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业简称:" prop="channelShortName">
              <el-input v-model="form.channelShortName" :readonly="isReadOnly" :maxlength="50" show-word-limit placeholder="请输入企业简称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="统一社会信用代码:" prop="creditCode">
              <el-input v-model="form.creditCode" :readonly="isReadOnly" :maxlength="18" show-word-limit placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业官网域名:" prop="website">
              <el-input v-model="form.website" :readonly="isReadOnly" :maxlength="50" show-word-limit placeholder="请输入企业官网域名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="经营模式:" prop="saleModel">
              <el-select v-model="form.saleModel" :disabled="isReadOnly" placeholder="请选择" @change="selectSaleModel">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="isShow" :span="11">
            <el-form-item label="线上平台名称:" prop="platformName">
              <el-input v-model="form.platformName" :readonly="isReadOnly" :maxlength="100" show-word-limit placeholder="请输入线上平台名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="法定代表人:" prop="legalRep">
              <el-input v-model="form.legalRep" :readonly="isReadOnly" :maxlength="50" show-word-limit placeholder="请输入法定代表人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="法定代表人联系电话:" prop="legalRepPhone">
              <el-input v-model="form.legalRepPhone" :readonly="isReadOnly" :maxlength="15" show-word-limit placeholder="请输入手机号或座机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="2025年企业销售额(万元):" prop="sales2025">
              <el-input-number v-model="form.sales2025" :min="1" :maxlength="10" :disabled="isReadOnly" placeholder="请输入2025年企业销售额"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业银行开户行名称:" prop="bankName">
              <el-input v-model="form.bankName" :readonly="isReadOnly" :maxlength="100" show-word-limit placeholder="请输入企业银行开户行名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业银行帐号:" prop="accountNo">
              <el-input v-model="form.accountNo" :readonly="isReadOnly" :maxlength="30" show-word-limit placeholder="请输入企业银行帐号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业注册地址:" prop="officeAddress">
              <el-input v-model="form.officeAddress" :readonly="isReadOnly" :maxlength="150" show-word-limit placeholder="请输入企业注册地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="注册地所在区:" prop="regLocation">
              <el-select v-model="form.regLocation" :disabled="isReadOnly" placeholder="请选择" filterable
                         allow-create
                         default-first-option>
                <el-option value="海淀区" key="海淀区" label="海淀区" />
                <el-option value="朝阳区" key="朝阳区" label="朝阳区" />
                <el-option value="昌平区" key="昌平区" label="昌平区" />
                <el-option value="西城区" key="西城区" label="西城区" />
                <el-option value="东城区" key="东城区" label="东城区" />
                <el-option value="丰台区" key="丰台区" label="丰台区" />
                <el-option value="通州区" key="通州区" label="通州区" />
                <el-option value="顺义区" key="顺义区" label="顺义区" />
                <el-option value="房山区" key="房山区" label="房山区" />
                <el-option value="大兴区" key="大兴区" label="大兴区" />
                <el-option value="怀柔区" key="怀柔区" label="怀柔区" />
                <el-option value="门头沟区" key="门头沟区" label="门头沟区" />
                <el-option value="石景山区" key="石景山区" label="石景山区" />
                <el-option value="延庆区" key="延庆区" label="延庆区" />
                <el-option value="平谷区" key="平谷区" label="平谷区" />
                <el-option value="密云区" key="密云区" label="密云区" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业业务联系人姓名:" prop="contact">
              <el-input v-model="form.contact" :readonly="isReadOnly" :maxlength="50" show-word-limit placeholder="请输入企业业务联系人姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="企业业务联系人电话:" prop="contactPhone">
              <el-input v-model="form.contactPhone" :readonly="isReadOnly" :maxlength="15" show-word-limit placeholder="请输入手机号或座机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="填报日期:" prop="submitDate">
              <el-date-picker
                  v-model="form.submitDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :disabled="isReadOnly"
                  placeholder="选择日期"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
            <el-col :span="11">
              <el-form-item label="本次上报商户数量:" prop="merchantNum">
                <el-input-number v-model="form.merchantNum" :disabled="isReadOnly" :min="1" placeholder="请输入数量"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="本次上报门店数量:" prop="storeNum">
                <el-input-number v-model="form.storeNum" :disabled="isReadOnly" :min="1" placeholder="请输入数量"></el-input-number>
              </el-form-item>
            </el-col>
          <el-col :span="24">
            <el-form-item label="经营范围:" prop="businessScope">
              <el-input type="textarea" v-model="form.businessScope" :readonly="isReadOnly" :rows="3" show-word-limit placeholder="请输入经营范围"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="企业简介:" prop="summary">
              <el-input type="textarea" :readonly="isReadOnly" show-word-limit :rows="5" v-model="form.summary" placeholder="请输入企业简介"></el-input>
            </el-form-item>
          </el-col>
        </el-collapse-item>
        <el-collapse-item title="渠道申报材料上传区" name="3">
        <el-col :span="24">
          <el-form-item label="" prop="technicalEmail">
            <div v-if="operator==='1'">
              <div v-if="flag!=='edit'" style="color: red;font-size: 13px">
                说明:上传文件名为企业名称.zip，政策参与渠道企业申请表中的信息必须与表单中的信息保持一致，所有上传的pdf附件均需要加盖公章，支付业务许可证线下必须提供，目录结构示例:<br/>
                企业名称<br/>
                &nbsp;&nbsp;-渠道上报材料<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;-政策参与渠道企业申请表.pdf、销售企业信息汇总表.xlsx、线上或线下参与补贴实施的门店信息汇总表.xlsx、
                营业执照复印件.pdf<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;企业《信用信息报告》.pdf、银行开户许可证复印件.pdf、承诺函.pdf、政策实施方案.pdf、支付业务许可证.pdf<br/>
                &nbsp;&nbsp;-商户上报材料<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;-商户A<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-营业执照复印件.pdf 、企业《信用信息报告》.pdf、同意函.pdf、承诺函.pdf<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;-商户B<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-营业执照复印件.pdf 、企业《信用信息报告》.pdf、同意函.pdf、承诺函.pdf
              </div>
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :before-upload="beforeUpload"
                :on-success="handleSuccess"
                :on-error="handleError"
                :show-file-list="true"
                :file-list="fileList"
                accept=".zip"
                :limit= "1"
                :on-remove="handleRemove"
              >
                <el-button size="mini" type="primary" v-if="flag!=='edit'" @click.stop="downloadTemplate()">模板下载</el-button>&nbsp;
                <el-button size="mini" type="primary" v-if="fileId===''">上传文件</el-button>
                <el-button size="mini" type="primary" @click="change()" v-else>重新上传</el-button>
              </el-upload>
              <template  v-if="flag!=='edit'">
                <div><br/>
                上传资料目录结构如下：
                </div>
                <div>
                  <el-image style="width: 65%; height: 65%" :src="lxImage" fit="cover"></el-image>
                </div>
              </template>
            </div>
            <div v-else>
              <div slot="content" v-for="(file, index) in fileListHis" :key="index">
                  <!-- <span v-if="userRole==='2' || userRole==='3'">-->
                    <el-button @click.native.prevent="bigFileDown(file)" type="text" size="small" >{{file.name }} （上传时间：{{file.createTime}}）</el-button>
                  <!-- </span>
                <span v-else>
                      {{file.name }} （上传时间：{{file.createTime}}）
                  </span> -->
              </div>
            </div>
          </el-form-item>
        </el-col>
        </el-collapse-item>
        </el-collapse>
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
      <div v-if="this.operator==='1'">
        <el-button size="mini" @click="back">返回</el-button>
        <el-button size="mini" type="primary" @click="save(0)">保存</el-button>
        <el-button size="mini" type="primary" @click="save(1)">提交</el-button>
      </div>
      <div v-else><el-button size="mini" @click="back">返回</el-button></div>
    </div>
  </div>
</template>
<script>
import {
  saveWorkflowInfo,deleteFileById,template,fileDownLoad,getWorkflowById,getWorkflowByWfType,getChannelById
} from "@/api/system/linXuanChannel/linXuanChannel";
import {SYS_APi_SCREENING_URL} from '@/utils/globals'
import axios from 'axios';
import * as util from "@/assets/js/util";
import lxImage from './lx.png';
export default {
  name: "index",
  data() {
    return {
      flag:"",
      lxImage:lxImage,
      patternStoreNum: /^[1-9]\d*$/,
      shenbaoType:'0',
      title:'',
      operator: '',
      wfType:'',
      isShow: false,
      isShowBut: true,
      buttonName:'文件上传',
      isReadOnly:false,
      pickerOptions: {
        disabledDate(time) {
          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth(); // 月份从 0 开始

          // 当月 1 号 00:00:00
          const startLimit = new Date(year, month, 1, 0, 0, 0);
          // 当月 11 号 00:00:00 （用作边界比较，因为时间戳包含时分秒）
          const endLimit = new Date(year, month, 11, 0, 0, 0);

          // 如果时间小于1号，或者大于等于11号，则禁用
          return time.getTime() < startLimit.getTime() || time.getTime() >= endLimit.getTime();
        }
      },
      options: [{
        value: '0',
        label: '线上'
      }, {
        value: '1',
        label: '线下'
      }],
      rules: {
        creditCode: [
          {trigger: "blur", required: true, message: "统一社会信用代码不能为空"},
          {
            trigger: "blur",
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: "请输入有效的18位统一社会信用代码"
          }
        ],
        channelName: [
          {trigger: "blur", required: true, message: "企业名称不能为空"},
        ],
        channelShortName: [
          {trigger: "blur", required: true, message: "企业简称不能为空"},
        ],
        saleModel: [
          {trigger: "blur", required: true, message: "经营模式不能为空"},
        ],
        platformName: [
          {trigger: "blur", required: true, message: "线上平台名称不能为空"},
        ],
        officeAddress: [
          {trigger: "blur", required: true, message: "企业注册地址不能为空"},
        ],
        regLocation: [
          {trigger: "blur", required: true, message: "注册地所在区不能为空"},
        ],
        businessScope: [
          {trigger: "blur", required: true, message: "经营范围不能为空"},
        ],
        summary: [
          {trigger: "blur", required: true, message: "企业简介不能为空"},
        ],
        sales2025: [
          {trigger: "blur", required: true, message: "2025年企业销售额"},
          {
            trigger: "blur",
            pattern: /^(\d+)(\.\d{1,2})?$/, // 核心：正数，可保留1-2位小数，支持纯整数
            message: "请输入有效的金额数字"
          }
        ],
        legalRep: [
          {trigger: "blur", required: true, message: "法定代表人不能为空"},
        ],
        legalRepPhone: [
          {trigger: "blur", required: true, message: "法定代表人联系电话不能为空"},
          {
            pattern: /^(1[3-9]\d{9})$|^(\d{3,4}-?\d{7,8})$/,
            message: "请输入有效的手机号或座机号",
            trigger: "blur"
          }
        ],
        contact: [
          {trigger: "blur", required: true, message: "企业业务联系人姓名不能为空"},
        ],
        contactPhone: [
          {trigger: "blur", required: true, message: "企业业务联系人电话不能为空"},
          {
            pattern: /^(1[3-9]\d{9})$|^(\d{3,4}-?\d{7,8})$/,
            message: "请输入有效的手机号或座机号",
            trigger: "blur"
          }
        ],
        bankName: [
          {trigger: "blur", required: true, message: "企业银行开户行名称不能为空"},
        ],
        accountNo: [
          {trigger: "blur", required: true, message: "企业银行帐号不能为空"},
          {
            trigger: "blur",
            pattern: /^\d{10,25}$/,
            message: "请输入有效的企业银行帐号"
          }
        ],
        merchantNum: [
          {trigger: "blur", required: true, message: "本次上报商户数量不能为空"},
          {
            trigger: "blur",
            pattern: /^[1-9]\d*$/,
            message: "本次上报商户数量必须为数值"
          }
        ],
        storeNum: [
          {trigger: "blur", required: true, message: "本次上报门店数量不能为空"},
          {
            trigger: "blur",
            pattern: /^[1-9]\d*$/,
            message: "本次上报门店数量必须为数值"
          }
        ],
        //storeNum: [
         // {validator: this.validateStoreNum, trigger: ['blur', 'change'], message: "本次上报门店数量不能为空"},
          /*{
            trigger: "blur",
            pattern: /^[1-9]\d*$/,
            message: "本次上报门店数量必须为数值"
          }*/
        //],
        submitDate: [
          {trigger: "blur", required: true, message: "填报日期不能为空"},
        ],
      },
      activeNames: ['1','2','3'],
      form: {},
      uploadUrl: '/file/uploadChunk',
      chunkSize: 9 * 1024 * 1024, // 每个块的大小，5MB
      fileList: [],
      fileListHis:[],
      fileId: '',
      uploadLoading: null,
      channelId:'',
      flowId:'',
      parentId:'',
      workFlow:null,
      flowState:''
    };
  },
  created(){
    this.userRole=util.session("userRole").userRole;
  },
  mounted() {
    this.initPage();
    this.initFromData();
  },
  methods: {
    initPage(){
      this.wfType=this.$route.params.wfType;
      this.operator=this.$route.params.operator;
      this.channelId=this.$route.params.channelId;
      this.flowState=this.$route.params.flowState;
      if(this.operator=="0"){//查看
        this.isReadOnly=true;
      }else{//修改
        this.isReadOnly=false;
      }
    },
    change(){
        this.fileList=[];
    },
    initFromData() {
      this.tableLoading = true;
      getWorkflowByWfType({
        wfType: this.wfType,
        channelId: this.channelId,
        operator: this.operator,
        flowState: this.flowState,
      }).then((res) => {
        this.tableLoading=false;
        if (res.code==200) {
          if(res.data != null && res.data.length>0) {
            this.flag=res.data[res.data.length-1].flag;
            if(this.flag==='edit'){
              this.getChannelInfo();
            } else {
              this.flowId=res.data[res.data.length-1].id;
              this.getWorkflowInfo();
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getChannelInfo(){
      this.tableLoading = true;
      getChannelById({
        id:this.channelId
      }).then((res) => {
        this.tableLoading=false;
        if (res.code==200) {
          if(res.data != null){
            if(res.data.channel!=null){
              this.form=res.data.channel;
            }
            this.fileList.push(res.data.fileName);
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
    getWorkflowInfo() {
      this.tableLoading = true;
      getWorkflowById({
        flowId: this.flowId,
      }).then((res) => {
        this.tableLoading=false;
        if (res.code==200) {
          if(res.data != null){
            if(res.data.channel!=null){
              this.form=res.data.channel;
              if(this.form.saleModel=='0'){
                this.isShow=true;
              }
              if(res.data.channel.auditState=="0" || res.data.channel.auditState=="4" || res.data.channel.auditState=="7"){
                this.isReadOnly=false;
              }else{
                this.isReadOnly=true;
              }
            }
            this.fileList=res.data.fileList;
            this.fileListHis=res.data.fileListHis;
            if(res.data.workflow != null){
              this.fileId=res.data.workflow.fileId;
              this.parentId=res.data.workflow.parentId;
              this.workFlow=res.data.workflow;
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleChange(val) {
      console.log(val);
    },
    back() {
      this.$router.go(-1);
    },
    selectSaleModel(value){
      this.form.saleModel=value;
      if(value==='0'){
        this.isShow=true;
      } else {
        this.isShow=false;
      }
    },
    validateStoreNum(rule, value, callback) {
      if (this.form.saleModel === '0') {
        return callback();
      }
      if (this.form.saleModel === '1' && !this.patternStoreNum.test(value)) {
          return callback(new Error('经营模式为线下时，本次上报门店数据量必须>=1'));
      }
      callback();
    },
    save(auditState) {
      if(auditState=="0" && this.form.channelName==""){
        this.$message.warning("企业名称不能为空");
      }else{
        this.$refs["validateForm"].validate((valid) => {
          if (valid) {
            if(this.flag!=='edit'){
              if(this.fileList.length==0 && auditState=="1"){
                this.$message.warning("请上传渠道申报材料！");
                return;
              }
              if(auditState=="1"&&(this.fileId==null || this.fileId=="")){
                this.$message.warning("请上传渠道申报材料！");
                return;
              }
            }
            /*if(auditState=="1"){//验证修改必须上传新材料文件
              if (this.workflow && this.workflow.id!=this.workflow.parentId){
                if((this.workFlow.wfState.indexOf("4")!=-1 || this.workFlow.wfState.indexOf("7")!=-1)
                    && this.fileId==this.workFlow.fileId){
                  this.$message.warning("渠道申报材料文件没有修改，还是原文件，请重新上传文件！");
                  return;
                }
              }
            }*/
              // const loading = this.$loading({
              //   lock: true,
              //   text: '正在保存数据',
              //   spinner: 'el-icon-loading',
              //   background: 'rgba(0, 0, 0, 0.7)'
              // });
           
            saveWorkflowInfo({
              wfType:this.wfType,
              fileId:this.fileId,
              wfState:auditState,
              channelInfo:this.form,
              flowId:this.flowId,
              parentId:this.parentId,
              flag:this.flag
            }).then((res) => {
              if (res.code == 200) {
                if(auditState=="0"){
                  this.$message({
                    type: "success",
                    message: "保存成功!",
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "提交成功!",
                  });
                }
                this.back();
              } else {
                this.$message.error(res.message);
              }
              //loading.close();
            });
          }else{
            this.$message.warning("必填项不能为空！");
          }
        });
      }
    },
    // 在文件上传之前拆分成多个块
    beforeUpload(file) {
      const allowedType = "zip";
      const fileSuffix = file.name.split(".").pop().toLowerCase();
      if (fileSuffix !== allowedType) {
        this.$message.error(`只允许上传.zip格式的压缩包文件！`);
        return false;
      }
      this.uploadLoading = this.$loading({
        lock: true,
        text: '文件上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.chunkedUpload(file);
      return false; // 取消默认的上传
    },
    // 分块上传
    async chunkedUpload(file) {
      const uploadId = Date.now()
      const totalChunks = Math.ceil(file.size / this.chunkSize);  // 计算总块数
      let start = 0;
      let end = this.chunkSize;
      let chunkIndex = 0;
      let uploadedChunks = 0; // 记录已上传块数
      // 更新 loading 文字
      this.updateLoadingText(`正在上传 0/${totalChunks}...`);
      // 上传每个块
      while (start < file.size) {
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('fileName', file.name);
        // 渠道申报：channel_insert、渠道退出：channel_quit、新增、修改商户/门店：merchant_insert、商户/门店退出：merchant_quit
        formData.append('uploadType', 'channel_insert');
        formData.append('uploadId', uploadId);
        formData.append('chunkIndex', chunkIndex); // 当前块的索引
        formData.append('totalChunks', totalChunks); // 总块数

        try {
          const response = await this.uploadChunk(formData); // 上传当前块
          console.log(response);
          if(response.data.code!=='200'){
              this.$message.error(`文件上传失败: ${response.data.message}`);
              this.closeLoading();
              break;
            }
          uploadedChunks++;
          // 更新进度
          const progress = Math.round((uploadedChunks / totalChunks) * 100);
          this.updateLoadingText(`正在上传 ${uploadedChunks}/${totalChunks} (${progress}%)`);
        
          if (chunkIndex === totalChunks - 1) {
            // 如果是最后一块，上传完成后显示信息
            this.handleSuccess(response, file, this.fileList);
            this.$message.success('文件上传完成');
            this.closeLoading();
          }
          start = end;
          end = Math.min(end + this.chunkSize, file.size);
          chunkIndex++;
        } catch (err) {
          console.error('上传失败:', err);
          this.$message.error(`文件上传失败: ${err.message}`);
          this.closeLoading();
          break;
        }
      }
    },
    // 更新 loading 文字
    updateLoadingText(text) {
      if (this.uploadLoading) {
        this.uploadLoading.setText(text);
      }
    },
    closeLoading() {
      if (this.uploadLoading) {
        this.uploadLoading.close();
        this.uploadLoading = null;
      }
    },

    // 上传每个文件块
    uploadChunk(formData) {
      return new Promise((resolve, reject) => {
        axios.post(SYS_APi_SCREENING_URL + this.uploadUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            resolve(response);  // 返回响应给调用者
          }).catch(error => {
            console.error('请求失败:', error);
            reject(error);
          });
      });
    },

    handleSuccess(response, file, fileList) {
      try {
        // 检查响应数据结构
        if (!response || !response.data) {
          throw new Error('服务器响应数据为空');
        }
        const fileId = response.data.data;
        if (!fileId) {
          throw new Error('无法获取文件ID');
        }
        this.fileId = fileId;
        console.log('文件上传成功,ID:', fileId);
        this.fileList.push({
          name: file.name,
          url: `${SYS_APi_SCREENING_URL}/file/download/${fileId}`, 
        });
      } catch (err) {
        this.fileId = "";
        console.error('处理上传响应失败:', err);
        this.$message.error(`上传成功但处理响应失败: ${err.message}`);
      }
    },

    handleError(error, file, fileList) {
      this.fileId = "";
      console.log('上传失败', error);
    },
    handleRemove(file, fileList) {
      if(this.fileId==""){
        const fileId = this.fileId;
        if (fileId) {
          deleteFileById({fileId: fileId}).then((res) => {
            if (res.code == 200) {
              this.fileList = fileList.filter(item => item.name !== file.name);
              this.$message({
                type: "success",
                message: "上传删除成功!",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }else{
        this.fileList=[];
      }
    },
    downloadTemplate() {
      const loading = this.$loading({
        lock: true,
        text: "正在下载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      template({
        type:"0"
      }).then((res) => {
        loading.close();
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.download = `遴选模板.zip`;
        a.click();
        window.URL.revokeObjectURL(url); // 释放该 url
        this.$message.success("下载成功");
      }).catch(error => {
        loading.close();
        this.$message.error("下载失败");
      });
    },
    fileDown(fileName) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      fileDownLoad({
        url:fileName.url,
        name:fileName.name
      }).then((res) => {
        loading.close();
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.download = fileName.name;
        a.click();
        window.URL.revokeObjectURL(url); // 释放该 url
        this.$message.success("下载成功");
      }).catch(error => {
        loading.close();
        this.$message.error("下载失败");
      });
    },
    bigFileDown(fileName) {
      // 获取 Token
      const token = this.$store.state.token; // 确保这里能取到 token
      if (!token) {
        this.$message.error("未登录，无法下载");
        return;
      }

      // 显示 Loading
      const loading = this.$loading({
        lock: true,
        text: "正在准备下载...",
        background: "rgba(0, 0, 0, 0.7)"
      });

      // 构造请求 URL (注意：不再拼 token 参数了)
      let apiUrl = SYS_APi_SCREENING_URL + "/filedown/bigFileDownLoad";
      const params = new URLSearchParams();
      params.append('url', fileName.url);
      params.append('name', fileName.name);
      const finalUrl = `${apiUrl}?${params.toString()}`;

      // 核心下载逻辑
      this.startStreamDownload(finalUrl, token, fileName.name)
          .then(() => {
            this.$message.success("下载成功");
          })
          .catch(err => {
            console.error(err);
            this.$message.error("下载失败或取消");
          })
          .finally(() => {
            loading.close();
          });
    },

    // 使用 Fetch API 进行流式下载
    async startStreamDownload(url, token, filename) {
      try {
        // 1. 弹出浏览器原生的“保存文件”对话框 (用户选择保存位置)
        // 这是关键：只有这样才能在 JS 中拿到一个可写入的流句柄
        const fileHandle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [{
            description: 'Zip File',
            accept: { 'application/zip': ['.zip'] },
          }],
        });

        // 2. 创建可写流
        const writableStream = await fileHandle.createWritable();

        // 3. 发起 Fetch 请求 (这里可以带上 Headers)
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'token': token, // 【关键】Token 放在 Headers 中
            // 如果还有其他必须的 Header，也在这里添加
          }
        });

        if (!response.ok) {
          throw new Error(`服务器错误: ${response.status}`);
        }

        // 4. 获取响应体的 Reader (读取流)
        const reader = response.body.getReader();

        // 5. 循环读取并写入硬盘
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            break;
          }
          // 将读取到的数据块写入文件流
          await writableStream.write(value);
        }

        // 6. 关闭流
        await writableStream.close();

      } catch (err) {
        // 如果用户点击了“取消”保存，err.name 会是 'AbortError'，可以忽略
        if (err.name !== 'AbortError') {
          throw err; // 重新抛出其他错误
        }
      }
    },
    // handleRemove(file, fileList) {
    //   const fileId = this.fileId;
    //   if (fileId) {
    //     deleteFileById({fileId: fileId}).then((res) => {
    //       if (res.code == 200) {
    //         this.fileList = fileList.filter(item => item.name !== file.name);
    //           this.$message({
    //               type: "success",
    //               message: "上传删除成功!",
    //           });
    //       } else {
    //           this.$message.error(res.message);
    //       }
    //     });
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-collapse-item__content{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.el-card {
  height: 100%;
}

.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}

.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.flex-item:nth-child(1),
.flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
}

.flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}
.role-form {
  margin: 15px 0;
}
.el-form-item {
  margin-bottom: 15px;
}
.el-form-item__label {
  line-height: 1.5;
}
.el-form-item__content {
  line-height: 1.5;
}
/* 可选：调整标题栏布局，让按钮靠右 */
::v-deep .custom-accordion .el-accordion-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 去掉默认标题文字的多余样式 */
::v-deep .custom-accordion .el-accordion-item__header-text {
  display: none;
}
</style>